<div
  class="flex items-center gap-1 bg-neutral-600 rounded-md px-1 py-[2px] gap-1 text-neutral-100 w-fit text-xs max-w-full"
>
  <i class="ph ph-sparkle text-yellow-500"></i>
  <span class="truncate">{{ label() }}</span>
  <button
    [disabled]="hasOutcome()"
    (click)="clearAgentMark()"
    class="w-3 h-3"
  >
    <i class="ph ph-x"></i>
  </button>
</div>
